import React from 'react';
import styled from "styled-components";
import {isEmpty} from "../../../helpers/helpers";
import Avatar from "../../../atoms/avatar";
import Stars from "../../../atoms/stars";
import Icon from "../../../atoms/icon";
import {Container, Info, Rate, Address, StarsCard, Title} from './styles';
import {getAvatar, getRealtorProfileUrl} from "../../../../models/user";
import ButtonLink from "../../../atoms/button.link";
import VerifiedBadgeIcon from '@icons/verified-badge.svg';
import ChevronLeftIcon from '@icons/chevron-left.svg';
import ButtonBase from "../../../atoms/button.base";

const RealtorsCard = ({realtor, className}) => {
    const profileUrl = getRealtorProfileUrl({
        agency_username: realtor.agency_username,
        realtor_city_name: realtor.city_name,
        realtor_district_name: realtor.district_name,
        realtor_slug: realtor.slug,
        agency_name: realtor.agency_name,
        fullName: realtor.fullName,
        username: realtor.username,
    });

    const avatarType = 'user';
    const avatarPath = getAvatar(realtor.id, !isEmpty(realtor.updated_at) ? realtor.updated_at : '');

    return (
        <a href={profileUrl}>
            <Container className={"mt-0 mt-lg-16 " + (className ?? '')}>
                <div className="position-relative">
                    <Avatar size="" className="agencies-avatar" src={avatarPath} type={avatarType} alt={realtor.fullName}/>
                </div>

                <Info className="mr-16 mr-lg-0">
                    <Title className="text-ellipsis realtor-name d-block mt-0 mt-lg-16" title={realtor.fullName}>
                        {realtor.fullName}
                    </Title>

                    <div className="d-flex align-items-center justify-content-lg-center">
                        <span className="text-ellipsis font-weight-light">{realtor.agency_name}</span>
                        {
                            (realtor.agency_authenticated) ?
                                <Icon width={16} height={16} className="mr-4"><VerifiedBadgeIcon/></Icon>
                                : ''
                        }
                    </div>

                    <div className="d-flex align-items-center justify-content-lg-center mt-4">
                        <StarsCard>
                            <Stars rate={!isEmpty(realtor.stars) ? realtor.stars : 0}/>
                        </StarsCard>

                        {
                            (!isEmpty(realtor.stars_count) && realtor.stars_count > 0) &&
                            <Rate className="mr-8">{realtor.stars_count} نفر</Rate>
                        }
                    </div>


                    <ButtonBase
                        variant="outline"
                        size="sm"
                        color="primary"
                        className="mt-24 d-none d-lg-inline-flex show-agency-page-btn"
                    >
                        نمایش پروفایل
                    </ButtonBase>
                </Info>

                <ButtonBase
                    variant="outline"
                    size="circle-32"
                    circle
                    color=""
                    className="mr-8 d-inline-flex d-lg-none"
                >
                    <Icon width={16} height={16} className="chevron-left-icon-link">
                        <ChevronLeftIcon/>
                    </Icon>
                </ButtonBase>
            </Container>
        </a>
    );
};

export default React.memo(RealtorsCard);

// styles